import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormControl, FormGroup, FormGroupDirective } from '@angular/forms';
@Component({
  selector: 'radioControl',
  templateUrl: './radio-control.component.html',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class RadioControlComponent implements OnInit {
  public formGroup: FormGroup;
  @Input() formControlFieldName: string;
  @Input() options: any[] = [];
  constructor(private ctrlContainer: FormGroupDirective) { }
  ngOnInit(): void {
    this.formGroup = this.ctrlContainer.form;
    const control = new FormControl('');
    this.formGroup.addControl(this.formControlFieldName, control);    
  }
}
